import "./App.css";
import { css } from "@emotion/react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import {
  Header,
  Top,
  TopContents,
  News,
  Comment,
  Original,
  Footer,
  Trailer,
  Character,
  Slider,
  Impressions,
  Swiper,
  Intro,
  Staff,
  Cast,
} from "./components/organisms/";

function Home() {
  return (
    <>
      <div css={appStyle}>
        <div css={bgImgStyle}>
          <div css={bgImgContainerStyle} />
        </div>
        <Header />
        <Top />
        {/* <TopContents /> */}
        <News />
        <Trailer />
        <Intro />
        <Character />
        {/* <Slider /> */}
        <Swiper />
        <Cast />
        <Staff />
        {/* <Comment /> */}
        <Impressions />
        <Original />
        <Footer />
      </div>
    </>
  );
}

function App() {
  return (
    <div className="App" css={appStyle}>
      <Router basename={process.env.REACT_APP_BASE_PATH}>
        <Routes>
          <Route path="/" element={<Home />} />
        </Routes>
      </Router>
    </div>
  );
}

const appStyle = css`
  position: relative;
  min-height: 100vh;
  font-family: "Noto Serif Japanese", serif;
  color: #fff;
`;

const bgImgStyle = css`
  z-index: -10;
  position: fixed;
  width: 100vw;
  height: 100vh;
  background-image: url(${process.env.REACT_APP_BASE_PATH +
  "/img/tumblr_back.webp"});
  background-size: cover;
  background-repeat: no-repeat;
`;

const bgImgContainerStyle = css`
  position: relative;
  width: 100%;
  height: 100%;
`;

export default App;
